import React, { useEffect } from 'react';
import FilterBar from '../filterBar';
import { Box, Grid, Skeleton } from '@mui/material';
import CacheSettingList from './CacheSettingList';
import { useDispatch, useSelector } from 'react-redux';
import { clearAllCache, getCacheList } from '../../../../redux/thunks/adminSettingsThunk';
import { CustomButton } from '../../../shared';
import { Trash } from '../../../../assets';

const CacheSetting = () => {
    const dispatch = useDispatch();
    const { company } = useSelector((state) => state.company);
    const { cacheSetting } = useSelector((state) => state.adminSettings);
    const { isCacheListLoading } = cacheSetting;
    useEffect(() => {
        if (company.id) {
            dispatch(getCacheList({ companyId: company.id }));
        }
    }, [company.id]);
    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Box className="mb-2">
                        <CustomButton
                            buttonColor="#AD509E"
                            handleClick={() => dispatch(clearAllCache({ companyId: company.id }))}
                            icon={<Trash color="#FFFFFF" />}
                            title="Clear All Cache"
                            titleColor="#FFFFFF"
                        />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    {isCacheListLoading ? (
                        <Skeleton
                            height={'300px'}
                            variant="rectangular"
                            width={'100%'}
                        />
                    ) : (
                        <CacheSettingList />
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export default CacheSetting;
